/** Max files in the cycle-level AI document library (process create / extraction). */
export const AI_LIBRARY_FILE_CAP = 5;
/** Max files linked to a single process (process edit document library). */
export const PROCESS_LIBRARY_FILE_CAP = 10;
/** Max files on manual create process (before the process exists). */
export const PROCESS_MANUAL_CREATE_FILE_CAP = 5;
/** Visible document rows before the process-details library scrolls. */
export const PROCESS_LIBRARY_VISIBLE_ROWS = 5;
/** Estimated row height (px) for process document list max-height. */
export const PROCESS_LIBRARY_ROW_HEIGHT_PX = 68;
/** Max files that can be selected for flowchart generation (process edit). */
export const PROCESS_FLOWCHART_SELECTION_CAP = 5;
export const AI_MAX_FILE_SIZE_MB = 5;
export const AI_MAX_FILE_SIZE_BYTES = AI_MAX_FILE_SIZE_MB * 1024 * 1024;
export const AI_MAX_FILENAME_LENGTH = 150;
export const AI_FILE_TAG_LIMIT = 3;
export const AI_FILE_TAG_MAX_LENGTH = 20;
export const AI_ACCEPTED_EXTENSIONS = ['pdf', 'docx'];

export const AI_DOCUMENT_TAG_OPTIONS = [
  { value: 'cycle transcript', label: 'Cycle Transcript' },
  { value: 'process transcript', label: 'Process Transcript' },
  { value: 'supporting doc', label: 'Supporting Doc' }
];

export const AI_LOADING_MESSAGES = [
  'Reading the selected process documents...',
  'Identifying process boundaries and owners...',
  'Comparing walkthrough notes across files...',
  'Drafting process candidates for review...',
  'Preparing editable process rows...'
];

export const aiTagSelectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 38,
    borderRadius: 8,
    fontSize: 13,
    backgroundColor: '#ffffff',
    borderColor: state.isFocused ? '#3b82f6' : '#e5e7eb',
    boxShadow: state.isFocused ? '0 0 0 2px rgba(59, 130, 246, 0.12)' : 'none',
    cursor: 'text',
    '&:hover': {
      borderColor: state.isFocused ? '#3b82f6' : '#d1d5db'
    }
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '4px 10px',
    gap: 4
  }),
  input: (base) => ({
    ...base,
    color: '#111827',
    margin: 0,
    padding: 0
  }),
  placeholder: (base) => ({
    ...base,
    color: '#9ca3af',
    fontSize: 13
  }),
  multiValue: (base) => ({
    ...base,
    borderRadius: 6,
    backgroundColor: '#f3f4f6',
    border: '1px solid #e5e7eb'
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: '#374151',
    fontSize: 12,
    fontWeight: 500,
    padding: '2px 6px'
  }),
  multiValueRemove: (base) => ({
    ...base,
    borderRadius: 4,
    color: '#6b7280',
    ':hover': {
      backgroundColor: '#e5e7eb',
      color: '#111827'
    }
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: 36
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: 4,
    color: '#9ca3af',
    ':hover': { color: '#6b7280' }
  }),
  dropdownIndicator: () => ({ display: 'none' }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
    borderRadius: 8,
    border: '1px solid #e5e7eb',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
    overflow: 'hidden'
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999
  }),
  menuList: (base) => ({
    ...base,
    padding: 4
  }),
  option: (base, state) => ({
    ...base,
    fontSize: 13,
    borderRadius: 6,
    backgroundColor: state.isFocused ? '#eff6ff' : '#ffffff',
    color: '#111827',
    cursor: 'pointer'
  })
};

export const getAiTagSelectStyles = (hasError = false) => ({
  ...aiTagSelectStyles,
  control: (base, state) => {
    const control = aiTagSelectStyles.control(base, state);
    if (!hasError) return control;
    return {
      ...control,
      borderColor: '#ef4444',
      boxShadow: state.isFocused ? '0 0 0 2px rgba(239, 68, 68, 0.12)' : 'none',
      '&:hover': {
        borderColor: '#ef4444'
      }
    };
  }
});
